import { render, staticRenderFns } from "./IncomeSetting.vue?vue&type=template&id=b35f4032"
import script from "./IncomeSetting.vue?vue&type=script&lang=js"
export * from "./IncomeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports